import React from 'react';
import StatementOfFaith from '../components/HomePage/StatementOfFaith';
const SOFPage = () => {
    return (
        <>
            <StatementOfFaith />
        </>
    );
}

export default SOFPage;
